import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MonitorSmartphone, LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function SessionKickedModal({ reason, isAdmin }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoToLogin = () => {
    if (isAdmin) {
      navigate('/admin/login');
    } else {
      navigate('/login');
    }
    window.location.reload();
  };

  const title = reason === 'device_replaced'
    ? t('session.kicked_title')
    : t('session.kicked_title');

  const description = reason === 'device_replaced'
    ? t('session.kicked_desc')
    : t('session.kicked_desc');

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" data-testid="session-kicked-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div
        className="relative w-full max-w-sm rounded-3xl p-6 shadow-2xl animate-in zoom-in-95 fade-in duration-300 text-center"
        style={{
          background: 'var(--glass-bg, #1e293b)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid var(--glass-border, rgba(51,65,85,0.4))',
        }}
      >
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5"
          style={{ background: 'rgba(239, 68, 68, 0.12)' }}
        >
          <MonitorSmartphone className="h-8 w-8 text-red-400" />
        </div>

        <h2
          className="text-lg font-bold mb-2"
          style={{ color: 'var(--theme-text, #fff)' }}
          data-testid="session-kicked-title"
        >
          {title}
        </h2>

        <p
          className="text-sm leading-relaxed mb-6"
          style={{ color: 'var(--theme-textSecondary, #94a3b8)' }}
          data-testid="session-kicked-description"
        >
          {description}
        </p>

        <Button
          onClick={handleGoToLogin}
          className="w-full rounded-xl h-11 font-medium gap-2 bg-indigo-600 hover:bg-indigo-500 text-white"
          data-testid="session-kicked-login-btn"
        >
          <LogIn className="h-4 w-4" />
          {t('session.kicked_cta')}
        </Button>
      </div>
    </div>
  );
}
